export const companyTableColumns = [
  {
    label: "企业名称",
    value: "targetName"
  },
  {
    label: "企业简称",
    value: "targetShortName"
  },
  {
    label: "状态",
    value: "status"
  },
  {
    label: "互联角色",
    value: "typeListStr"
  },
  {
    label: "备注",
    value: "description"
  },
  {
    label: "操作",
    value: "operate"
  }
]

export const typeTableColumns = [
  {
    label: "互联角色",
    value: "name"
  },
  {
    label: "互联企业数量",
    value: "count"
  },
  {
    label: "描述",
    value: "description"
  }
]

export const connectTab = [
  {
    label: "对接我的企业",
    value: "me"
  },
  {
    label: "我对接的企业",
    value: "you"
  }
]

export const searchableInfos = [
  {
    label: "企业名称",
    value: "targetName"
  },
  {
    label: "互联角色",
    value: "typeIds"
  }
]
